import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function MaskedLines({ lines, className = "", lineClassName = "", delay = 0, stagger = 0.1 }) {
    return (
        <div className={className}>
            {lines.map((line, i) => (
                <div key={i} className="overflow-hidden">
                    <motion.div
                        className={lineClassName}
                        initial={{ y: "115%" }}
                        animate={{ y: "0%" }}
                        transition={{ duration: 1.15, ease: EASE, delay: delay + i * stagger }}
                    >
                        {line}
                    </motion.div>
                </div>
            ))}
        </div>
    );
}

export function MaskedInView({ children, delay = 0, className = "" }) {
    return (
        <div className={`overflow-hidden ${className}`}>
            <motion.div
                initial={{ y: "115%" }}
                whileInView={{ y: "0%" }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 1.05, ease: EASE, delay }}
            >
                {children}
            </motion.div>
        </div>
    );
}

export function Reveal({ children, delay = 0, y = 44, className = "" }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: EASE, delay }}
        >
            {children}
        </motion.div>
    );
}